import React from 'react';
import { Link } from 'react-router-dom';
import GoogleAnalytics from '../components/GoogleAnalytics';

const services = [
    {
        title: 'Pune to Kolhapur Cab',
        description: 'Seamless Pune to Kolhapur Cab with SHREE Tours & Travels – Comfortable, Affordable and Always On Time. Book your hassle-free ride today!',
        image: '/images/keyword/1.jpg',
        icon: 'flaticon-taxi-2',
        link: '/Pune-to-Kolhapur-Cab',  // Unique path for this service
    },
    {
        title: 'Pune to Mumbai Cab',
        description: 'Smooth and Hassle-Free Pune to Mumbai Cab with SHREE Tours & Travels – Affordable, Safe and Punctual. Book your ride now!',
        image: '/images/keyword/2.jpg',
        icon: 'flaticon-taxi-2',
        link: '/Pune-to-Mumbai-Cab',  // Unique path for this service
    },
    {
        title: 'Pune to Shirdi Cab',
        description: 'Convenient Pune to Shirdi Cab with SHREE Tours & Travels – Safe, Comfortable and Perfect for Your Pilgrimage. Book Your Ride Today!',
        image: '/images/keyword/6.jpg',
        icon: 'flaticon-taxi-2',
        link: '/Pune-to-Shirdi-Cab',  // Unique path for this service
    },
    {
        title: 'Pune to Mahabaleshwar Cab',
        description: 'Enjoy a Comfortable Pune to Mahabaleshwar Cab with SHREE Tours & Travels – Safe, Affordable and Perfect for a Scenic Getaway. Book Your Ride!',
        image: '/images/keyword/4.jpg',
        icon: 'flaticon-taxi-2',
        link: '/Pune-to-Mahabaleshwar-Cab',  // Unique path for this service
    },
    {
        title: 'Pune to Bhimashankar Cab',
        description: 'Reliable Pune to Bhimashankar Cab with SHREE Tours & Travels – Comfortable, Affordable and Ideal for a Spiritual Journey. Book Your Trip Now!',
        image: '/images/keyword/5.jpg',
        icon: 'flaticon-taxi-2',
        link: '/Pune-to-Bhimashankar-Cab',  // Unique path for this service
    },
    {
        title: 'Pune to Nashik Cab Service',
        description: 'Hassle-Free Pune to Nashik Cab with SHREE Tours & Travels – Comfortable, Affordable and Perfect for Business or Pilgrimage. Book Your Journey Now!',
        image: '/images/keyword/7.jpg',
        icon: 'flaticon-taxi-2',
        link: '/Pune-to-Nashik-Cab',  // Unique path for this service
    },
    {
        title: 'Pune Airport Pickup and Drop',
        description: 'Reliable Pune Airport Pickup and Drop Service with SHREE Tours & Travels – Safe, Comfortable and On-Time for Your Airport Journey. Book Your Ride Now!',
        image: '/images/keyword/8.jpg',
        icon: 'flaticon-taxi-2',
        link: '/Pune-Airport-Pickup-and-Drop',  // Unique path for this service
    },
    {
        title: 'Pune To Mumbai Airport Cab',
        description: 'Book your comfortable and timely Pune to Mumbai Airport Cab with SHREE Tours & Travels. Enjoy a stress-free ride with our reliable service.',
        image: '/images/keyword/9.jpg',
        icon: 'flaticon-taxi-2',
        link: '/Pune-To-Mumbai-Airport-Cab',  // Unique path for this service
    },        
    {
        title: 'Mumbai To Kolhapur Cab Service',
        description: 'Comfortable and Affordable Mumbai to Kolhapur Cab Service with SHREE Tours & Travels – Perfect for a Smooth and Relaxed Journey. Book Your Ride Now!',
        image: '/images/keyword/12.jpg',
        icon: 'flaticon-taxi-2',
        link: '/Mumbai-To-Kolhapur-Cab',  // Unique path for this service
    },
];


const Service = () => {
    return (
        <div>
            <GoogleAnalytics/>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/hero3.jpg)' }}
            >
                <div className="auto-container">
                    <div className="title-outer text-center">
                        <h1 className="title">Services</h1>
                    </div>
                </div>
            </section>

            <section className="service-section-three pb-90 pt-5">
                <div className="auto-container container">
                    <div className="row">
                        {services.map((service, index) => (
                            <div className="col-lg-4 col-sm-6 boorderr" key={index}>
                                {/* Service Block */}
                                <div className="service-block-three">
                                    <div className="inner-box">
                                        <div className="image-box borderr">
                                            <figure className="image">
                                                <img src={service.image} alt={service.title} />
                                            </figure>
                                            <i className={`icon ${service.icon}`}></i>
                                        </div>
                                        <div className="content bg-darkkkk">
                                            <h4 className="darkcolorrr">
                                                <Link className="darkcolorrr" to={service.link}>{service.title}</Link>
                                            </h4>
                                            <div className="text-dark">{service.description}</div>
                                            <Link to={service.link} className="icon fa fa-angle-double-right"></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Service;
